import { useTranslation } from "../../hooks/useTranslation";

export function ClaimFilterActual({ setFilter, filter }) {
  const { t } = useTranslation();

  const stateNames = {
    open: t("claims.stateOpen"),
    in_progress: t("claims.stateInProgress"),
    closed: t("claims.stateClosed"),
  };

  const deleteFromFilter = (key) => {
    if (key === "state") {
      setFilter({
        ...filter,
        state: [],
      });
    } else {
      setFilter({
        ...filter,
        [key]: "",
      });
    }
  };

  const deletableFilters = [
    ["fulltext", t("common.fulltext"), "string"],
    ["state", t("claims.state"), "state"],
    ["date_from", t("claims.dateFrom"), "date"],
    ["date_to", t("claims.dateTo"), "date"],
  ];

  let isFilterFill = false;
  deletableFilters.forEach((deletableFilter) => {
    if (filter && deletableFilter[0] in filter && filter[deletableFilter[0]]) {
      if (Array.isArray(filter[deletableFilter[0]])) {
        if (filter[deletableFilter[0]].length > 0) {
          isFilterFill = true;
        }
      } else {
        isFilterFill = true;
      }
    }
  });

  if (!isFilterFill) {
    return <></>;
  }

  return (
    <div className="d-lg-flex gap-2 py-3 border-bottom">
      {deletableFilters.map(
        (deletableFilter, key) =>
          deletableFilter[0] in filter &&
          filter[deletableFilter[0]] &&
          (!Array.isArray(filter[deletableFilter[0]]) ||
            (Array.isArray(filter[deletableFilter[0]]) &&
              filter[deletableFilter[0]].length > 0)) && (
            <div className="btn-group" key={key}>
              <button className="btn btn-sm btn-secondary">
                {deletableFilter[1]}:&nbsp;
                <strong>
                  {deletableFilter[2] === "string" &&
                    filter[deletableFilter[0]]}
                  {deletableFilter[2] === "date" &&
                    new Date(filter[deletableFilter[0]]).toLocaleDateString()}
                  {deletableFilter[2] === "state" &&
                    filter[deletableFilter[0]].map(
                      (state, sindex) =>
                        (sindex > 0 ? ", " : "") + (stateNames[state] || state)
                    )}
                </strong>
              </button>
              <button
                className="btn btn-sm btn-danger"
                onClick={() => deleteFromFilter(deletableFilter[0])}
              >
                <i className="ki-solid ki-trash text-white"></i>
              </button>
            </div>
          )
      )}
    </div>
  );
}
